var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.65964C0.723858 3.65964 0.5 3.8835 0.5 4.15964C0.5 4.43578 0.723858 4.65964 1 4.65964L1 3.65964ZM7.35355 4.51319C7.54882 4.31793 7.54882 4.00135 7.35355 3.80608L4.17157 0.624104C3.97631 0.428842 3.65973 0.428842 3.46447 0.624104C3.2692 0.819366 3.2692 1.13595 3.46447 1.33121L6.29289 4.15964L3.46447 6.98806C3.2692 7.18333 3.2692 7.49991 3.46447 7.69517C3.65973 7.89043 3.97631 7.89043 4.17157 7.69517L7.35355 4.51319ZM1 4.65964L7 4.65964L7 3.65964L1 3.65964L1 4.65964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a1854e004b0a3d18e1288e502fb1c904.svg";
export { ForwardRef as ReactComponent };